// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Common = require("../utils/Common.bs.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("../mm-utils/MM_context.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Belt_HashSetInt = require("rescript/lib/js/belt_HashSetInt.js");
var MM_parenCounter = require("../mm-utils/MM_parenCounter.bs.js");
var MM_substitution = require("../mm-utils/MM_substitution.bs.js");
var MM_wrk_ctx_data = require("./MM_wrk_ctx_data.bs.js");
var Belt_HashSetString = require("rescript/lib/js/belt_HashSetString.js");

function preCtxDataMake(settings) {
  return {
          settingsV: Common.versionMake(settings),
          srcs: [],
          ctxV: Common.versionMake(MM_context.createContext(undefined, undefined, undefined)),
          frms: undefined,
          parenCnt: MM_parenCounter.parenCntMake([], undefined, undefined),
          syntaxTypes: []
        };
}

function findSyntaxTypes(ctx, frms) {
  var syntaxTypes = Belt_HashSetInt.make(16);
  MM_context.forEachHypothesisInDeclarationOrder(ctx, (function (hyp) {
          if (hyp.typ === /* F */0) {
            Belt_HashSetInt.add(syntaxTypes, Caml_array.get(hyp.expr, 0));
          }
          
        }));
  Belt_MapString.forEach(frms, (function (param, frm) {
          frm.frame.hyps.forEach(function (hyp) {
                if (hyp.typ === /* F */0) {
                  return Belt_HashSetInt.add(syntaxTypes, Caml_array.get(hyp.expr, 0));
                }
                
              });
        }));
  return Belt_HashSetInt.toArray(syntaxTypes);
}

function preCtxDataUpdate(preCtxData, settings, ctx, param) {
  var settingsV = Belt_Option.mapWithDefault(settings, preCtxData.settingsV, (function (settings) {
          return Common.versionSet(preCtxData.settingsV, settings);
        }));
  var match = Belt_Option.mapWithDefault(ctx, [
        preCtxData.srcs,
        preCtxData.ctxV
      ], (function (param) {
          return [
                  param[0],
                  Common.versionSet(preCtxData.ctxV, param[1])
                ];
        }));
  var ctxV = match[1];
  MM_context.moveConstsToBegin(ctxV.val, settingsV.val.parens);
  var ctxV$1 = Common.versionSet(ctxV, ctxV.val);
  var frms = MM_substitution.prepareFrmSubsData(ctxV$1.val, Caml_option.some(Belt_HashSetString.fromArray(settingsV.val.asrtsToSkip)), undefined);
  var parenCnt = MM_parenCounter.parenCntMake(MM_wrk_ctx_data.prepareParenInts(ctxV$1.val, settingsV.val.parens), true, undefined);
  var syntaxTypes = findSyntaxTypes(ctxV$1.val, frms);
  return {
          settingsV: settingsV,
          srcs: match[0],
          ctxV: ctxV$1,
          frms: frms,
          parenCnt: parenCnt,
          syntaxTypes: syntaxTypes
        };
}

exports.preCtxDataMake = preCtxDataMake;
exports.preCtxDataUpdate = preCtxDataUpdate;
exports.findSyntaxTypes = findSyntaxTypes;
/* Common Not a pure module */
